module.exports = __webpack_public_path__ + "static/banner-tv-lapis-pega-strass-336a41d23e8af9e61fdae74675fe5aeb.jpg";